import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/material';
import { formattedDate } from '../DateUtils';
import { postActionDataRefresh } from "../CommonUtils";
import DatatTable from '../Table';
import {  IconButton, Tab, FormControl } from '@mui/material';
import ShowDataTable from '../Tables/ShowDataTable';
import { Close as CloseIcon } from '@mui/icons-material'
import Timer from '../../basic-component/Timer'
import Card from 'react-bootstrap/Card';
import styles from '../../basic-component/form-component/feedback-form/ViewFeedbackDetails.module.css';
import { acceptFeedbackAfterOnClickURL, addReceiptURL, apiHostUrl, closeFeedbackFromAddReceiptURL } from '../../../../constants/constants';
import useAxiosFetchData from '../../../hooks/useAxiosFetchData';
import { useSelector } from 'react-redux';
// import useAddModal from '../../../../hooks/useAddModal';
import Snackbar from '@mui/material/Snackbar';
import { use } from 'i18next';
import { t } from 'i18next';
import ReadOnlyTextField from '../ReadOnlyTextField';
import { FormRow, GridContainer } from '../../../../styles/styled-component';
import TextLabel from '../TextLabel';
import {Button} from 'react-bootstrap';
import {useDispatch} from 'react-redux';
import {setResponsePendingReducer} from '../../../system/redux/reducers/ResponsePendingReducer';

function AddReceiptModalBody({ open, handleClose, val, onClose, snackbarMessageHandler, snackBarSwitch, disableReceiptViewHandler, setItemData, onModalCloseHandler, parentModalOnClose, modalSwitchHandler,scoopDataForClosure }) {
    const { i18n, t } = useTranslation();
    const dispatch = useDispatch();
    const [timer, setTimer] = useState(10);
    const [lastopen, setLastOpen] = useState(false);
    const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
    const { homeLink } = useSelector((state) => state.role);
    const {assignGroupOnSubmit:OnSubmitResponsePending} = useSelector(state => state.ResponsePendingReducer);
    const [headers, setHeaders] = useState({
        'X-Csrf-Token': csrfToken,
        'Content-Type': 'application/json'
    });
    const [addReceiptData, setAddReceiptData] = useState(null);
    const [closeFeedbackPayload, setCloseFeedbackPayload] = useState(null);
    const { fetchData: postAddReceiptData } = useAxiosFetchData({
        url: `${apiHostUrl}${homeLink}${addReceiptURL}`,
        headers: headers,
        method: 'post',
        body: addReceiptData,
        onLoad: false
    })
    const { fetchData: closeFeedback } = useAxiosFetchData({
        url: `${apiHostUrl}${homeLink}${closeFeedbackFromAddReceiptURL}`,
        headers: headers,
        method: 'post',
        body: closeFeedbackPayload,
        onLoad: false
    })
    const handleCancelClick = () => {
        // handleClose();
        // debugger;
        modalSwitchHandler("Parent");
        onModalCloseHandler();
    };
    const handleTimerUpdate = newTime => {
        if (newTime <= 0 && !OnSubmitResponsePending) {
            // handleClose();
            handleCancelClick();
            // onClose();
        } else {
            setTimer(newTime);
        }
    };
    const generateAppropriateDate = (value) => {
        const date = new Date(value);
        const options = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        };

        const formattedDate = [
            ('0' + date.getDate()).slice(-2), // Day
            ('0' + (date.getMonth() + 1)).slice(-2), // Month
            date.getFullYear(), // Year
        ].join('-') + ' ' + date.toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit' });

        return formattedDate;
    }


    const lasthandleClose = () => {
        setLastOpen(false);
    };
    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={lasthandleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );
    const handleOnAccept = () => {
        console.log("Accepting............");
        dispatch(setResponsePendingReducer({assignGroupOnSubmit: true}));
        let payload = null;
        debugger;
        if (val.OperationType === "ADD") {
            payload = {
                user: {
                    id: val.bidderId
                },
                departmentId: val.departmentId,
                feedbackId: val.feedbackId,
                feedbackTypeId: val.feedbackTypeId,
                assignmentTime: (val.assignmentTime),
                warningTime_str: (val.warningTime),
                subAreaId: val.subAreaId,
                priorityId:val.priorityId,
                departmentSlaAssignmentList: val.departmentSlaAssignmentList,
                departmentSlaEscalationList: val.departmentSlaEscalationList,
                taggedFeedbackList: val.taggedFeedbackList,
                pickUpSlaAssignmentObj: val.pickUpSlaAssignmentObj,
                departmentSlaAssignment: val.departmentSlaAssignment,

            }
            setAddReceiptData(payload);
        }
        console.log(val);
        debugger;
        if (val.OperationType === "CLOSE") {
            payload = {
              assignmentTime: val.assignmentTime,
              departmentSlaAssignmentList: val.departmentSlaAssignmentList,
              departmentSlaEscalationList: val.departmentSlaEscalationList,
              taggedFeedbackList: val.taggedFeedbackList,
              pickUpSlaAssignmentObj: val.pickUpSlaAssignmentObj,
              feedbackId: val.feedbackId,
              feedbackTypeId: val.feedbackTypeId,
              subAreaId: val.subAreaId,
              priorityId: val.priorityId,
              warningTime_str: val.warningTime,
            };
            setCloseFeedbackPayload(payload);
        }

    }
    useEffect(() => {
        console.log("Add Receipt Data: ", addReceiptData);
        console.log("Close Feedback Payload: ", closeFeedbackPayload);
        console.log("ops type", val);
        if (addReceiptData !== null || closeFeedbackPayload !== null) {
            if (val.OperationType === "ADD") {
                postAddReceiptData().then((res) => {
                    dispatch(setResponsePendingReducer({assignGroupOnSubmit: false}));
                    val.onSuccess(true);
                    console.log(res);
                    //alert(`Success: ${res.success}\n receipt count: ${res.receiptDetails.receiptCount} \n receipt target id: ${res.receiptDetails.receiptTargetId}`)
                    snackbarMessageHandler(t('general.label.msg.addReceipt'));
                    snackBarSwitch(true);

                    if(res && res.success && res.receiptDetails.receiptTargetId && res.receiptDetails.receiptTargetId > 0){
                        postActionDataRefresh(2, null);
                    }

                    onModalCloseHandler();
                    parentModalOnClose();
                    // modalSwitchHandler("Parent");
                    // handleClose();
                    // onClose(t('general.label.msg.addReceipt'));
                    // onModalCloseHandler();
                })
            }
            if (val.OperationType === "CLOSE") {
                closeFeedback().then((res) => {
                    if (res && res != null) {
                        // setItemData((prev) => ({ ...prev, receiptTargetId: res.receiptTargetId, feedbackId: res.feedbackId }))
                        console.log(res);
                        scoopDataForClosure(res.receiptTargetId);
                        val.onSuccess(true);
                        dispatch(setResponsePendingReducer({assignGroupOnSubmit: false}));
                        // alert("Now go to close feedback page and close the feedback.")
                        // snackbarMessageHandler(t('general.closeFeedbackSuccess.level'));
                        // snackBarSwitch(true);
                        // snackbarMessageHandler(t('general.closeFeedbackSuccess.level'));
                        onModalCloseHandler();
                        // parentModalOnClose();
                        modalSwitchHandler("Close");
                        // disableReceiptViewHandler(true);

                        // handleClose();
                        // onClose(t('general.label.msg.acceptReceiptSuccess'));
                    }
                    else {
                        snackbarMessageHandler(t('general.closeFeedbackFailure.level'));
                        snackBarSwitch(true);
                        // parentModalOnClose();
                        onModalCloseHandler();

                    }
                })
            }

        }
    }, [addReceiptData, closeFeedback, closeFeedbackPayload, disableReceiptViewHandler, handleClose, onClose, postAddReceiptData, setItemData, snackBarSwitch, snackbarMessageHandler, t, val])
    return (
        <div className='assign-area'>

            <Timer text={t('general.lable.acceptReceipt')} countdown={timer} onTimerUpdate={handleTimerUpdate} sec={t('general.lable.acceptReceiptTime')} />

            <GridContainer>
                <FormRow>
                    <TextLabel title={t("general.lable.slaCondition")} isMandatory />
                    <FormControl sx={{ m: 1, minWidth: 120, width: "-webkit-fill-available" }}>
                        <ReadOnlyTextField value={val.SLAConditionName} />
                    </FormControl>

                </FormRow>
                <FormRow>
                    <TextLabel title={t("report.page.aging.table.header.feedbacktype")} isMandatory />
                    <FormControl sx={{ m: 1, minWidth: 120, width: "-webkit-fill-available" }}>
                        <ReadOnlyTextField value={val.FeedbackTypeName} />
                    </FormControl>
                </FormRow>
                <FormRow>
                    <TextLabel title={t("menu.key.master.area")} isMandatory />
                    <FormControl sx={{ m: 1, minWidth: 120, width: "-webkit-fill-available" }}>
                        <ReadOnlyTextField value={val.MasterArea} />
                    </FormControl>
                </FormRow>
                <FormRow>
                    <TextLabel title={t("menu.key.sub.area")} isMandatory />
                    <FormControl sx={{ m: 1, minWidth: 120, width: "-webkit-fill-available" }}>
                        <ReadOnlyTextField value={val.SubArea} />
                    </FormControl>

                </FormRow>
            </GridContainer>

            {val && val.PickupTargetComponent}

            {val && val.ResolutionTargetComponent}

            {val && val.ResolutionEscalationMatrixComponent}




            <Box mt={2} display="flex" justifyContent="space-between">
                {/* <Button variant="contained" sx={{
                    backgroundColor: '#2e7d32',
                    color: 'white',
                    borderRadius: '8px',
                    fontFamily: 'Lato',
                    fontWeight: 400,
                    '&:hover': {
                        backgroundColor: '#2e7d32',
                    },
                }} onClick={handleCancelClick}>
                    {t('general.button.cancel.label')}
                </Button> */}
                {/* <Button variant="contained" className='' sx={{
                    // backgroundColor: '#2e7d32',
                    color: 'white',
                    borderRadius: '8px',
                    fontFamily: 'Lato',
                    fontWeight: 400,
                    // '&:hover': {
                    //     backgroundColor: '#2e7d32',
                    // },
                }} onClick={handleOnAccept}>
                    {val.OperationType === "ADD" ? t('general.button.submit.label') : t("menu.key.feedback.close")}
                </Button> */}
                <Button disabled={OnSubmitResponsePending} variant="outline-dark" className='ms-2' onClick={handleCancelClick} buttonText={t('general.button.cancel.label')}>{t('general.button.cancel.label')}</Button>
                <Button disabled={OnSubmitResponsePending} variant="primary" className='ms-2' onClick={handleOnAccept} buttonText={val.OperationType === "ADD" ? t('general.button.submit.label') : t("menu.key.feedback.close")}>{val.OperationType === "ADD" ? t('general.button.submit.label') : t("menu.key.feedback.close")}  {OnSubmitResponsePending && <span className="spinner-border spinner-border-sm ml-2"></span>}</Button>
            </Box>
        </div>
    )
}

export default AddReceiptModalBody